import { useEffect } from 'react';
import { api } from '../lib/api';

/**
 * SiteThemeProvider — fetches /api/site-theme once at boot and applies it as
 * CSS variables on :root. Listens for the custom 'cmic:theme-updated' event so
 * the admin theme page can trigger a live re-fetch after saving without a
 * full page reload.
 *
 * CSS vars applied:
 *   --cmic-primary  (hex)
 *   --cmic-accent   (hex)
 *   --font-heading  (font-family string)
 *   --font-body     (font-family string)
 *
 * Falls back silently to the defaults declared in index.css if the API fails.
 */
export default function SiteThemeProvider({ children }) {
  useEffect(() => {
    let alive = true;
    const apply = (t) => {
      if (!alive || !t) return;
      const r = document.documentElement;
      if (t.primary_color) r.style.setProperty('--cmic-primary', t.primary_color);
      if (t.accent_color) r.style.setProperty('--cmic-accent', t.accent_color);
      if (t.heading_font) r.style.setProperty('--font-heading', t.heading_font);
      if (t.body_font) r.style.setProperty('--font-body', t.body_font);
    };
    const load = () => api.get('/site-theme').then(({ data }) => apply(data)).catch(() => {});
    load();
    const onUpdate = () => load();
    window.addEventListener('cmic:theme-updated', onUpdate);
    return () => {
      alive = false;
      window.removeEventListener('cmic:theme-updated', onUpdate);
    };
  }, []);
  return children;
}
